import React, { Component } from "react";
// styles for page
import "./reg_step4.css";
// icons for page
import Ionicon from "react-ionicons";
// react input tags
import { WithContext as ReactTags } from "react-tag-input";
// request module
import axios from "axios";
// navigaion arrows
import { NavigationArrow } from "../other components/navigation_arrow";
import { Saved } from "../other components/savedAlert";

const KeyCodes = {
  comma: 188,
  enter: 13
};
const delimiters = [KeyCodes.comma, KeyCodes.enter];

export default class RegStep4 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //
      url: " ",
      tags: [],
      productORservice: null,
      targetCountries: [],
      discribeQuestion: "",
      //
      visible: null,
      suggestions: [
        { id: "USA", text: "USA" },
        { id: "Germany", text: "Germany" },
        { id: "Austria", text: "Austria" },
        { id: "Costa Rica", text: "Costa Rica" },
        { id: "Sri Lanka", text: "Sri Lanka" },
        { id: "Thailand", text: "Thailand" }
      ],
      saved: false
    };
  }
  urlValidation = () => {
    if (this.state.url.length < 5) {
      this.setState({
        visible: false
      });
    } else {
      this.setState({
        visible: true
      });
    }
  };
  componentDidUpdate = () => {
    if (this.state.productORservice == "product") {
      this.refs.A.style.background = "green";
    } else {
      this.refs.A.style.background = "white";
    }
    if (this.state.productORservice == "service") {
      this.refs.B.style.background = "green";
    } else {
      this.refs.B.style.background = "white";
    }
  };
  handleChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  handleDeleteCountries = i => {
    const { targetCountries } = this.state;
    this.setState({
      targetCountries: targetCountries.filter((tag, index) => index !== i)
    });
  };
  handleAdditionCountries = tag => {
    this.setState(state => ({
      targetCountries: [...state.targetCountries, tag]
    }));
  };

  handleAddition = tag => {
    this.setState(state => ({ tags: [...state.tags, tag] }));
  };
  handleDelete = i => {
    const { tags } = this.state;
    this.setState({
      tags: tags.filter((tag, index) => index !== i)
    });
  };
  componentWillReceiveProps = nextProps => {
    if (nextProps.save && nextProps.save === 4 && nextProps.show === 1)
      this.SendData();
    if (nextProps.action === "undo") {
      alert("4 undo ");
    }
    if (nextProps.action === "redo") {
      alert("4 redo ");
    }
  };
  SendData = () => {
    let categories,
      countries = "";
    for (let i = 0; i < this.state.tags.length; i++) {
      categories += this.state.tags[i].text + ",";
    }
    for (let i = 0; i < this.state.targetCountries.length; i++) {
      countries += this.state.targetCountries[i].text + ",";
    }
    categories = categories.slice(1, categories.length - 1);
    countries = countries.slice(1, countries.length - 1);
    let formData = new FormData();
    let data = JSON.stringify({
      categories: categories,
      type: this.state.productORservice,
      countries: countries,
      description: this.state.discribeQuestion
    });
    formData.append("sub", window.localStorage.getItem("subdomain"));
    formData.append("page", "last page");
    formData.append("type", "finish");
    formData.append("config", data);
    // your request here
    for (var pair of formData.entries()) {
      console.log(pair[0] + ", " + pair[1]);
    }
  };
  saveAlert = () => {
    setTimeout(
      () =>
        this.setState({
          saved: true
        }),
      0
    );
    setTimeout(
      () =>
        this.setState({
          saved: false
        }),
      1500
    );
  };

  render = () => {
    const { tags, targetCountries } = this.state;
    let style;
    this.props.show
      ? (style = { display: "block" })
      : (style = { display: "none" });
    return (
      <div className="regStep step4" style={style}>
        <span>{NavigationArrow("prev")}</span>
        <div className="step4Heading">Tell us about your project</div>
        <div className="infoStep ">
          <div className="infoStepHeading">
            <p>
              1{" "}
              <Ionicon
                icon="ios-arrow-round-forward"
                fontSize="30px"
                className="stepIcon"
              />
              &nbsp; Choose slug for your url
            </p>
          </div>
          <div className="infoStepBody">
            <label>
              <input
                type="url"
                placeholder=""
                size={this.state.url.length}
                minLength="3"
                maxLength="12"
                value={this.state.url}
                onChange={this.handleChange}
                name="url"
              />
              <span className="addUrl">.OURSITE.COM</span>
              {this.state.visible ? (
                <span className="succes urlValidate perfectCenter">
                  <Ionicon icon="ios-checkmark" fontSize="50px" color="green" />
                  OK
                </span>
              ) : (
                <span className="warrning urlValidate perfectCenter">
                  <Ionicon icon="ios-close" fontSize="50px" color="red" />
                  Chosen name is not aviable ,please change
                </span>
              )}
            </label>

            <button className="checkButton " onClick={this.urlValidation}>
              OK
              <Ionicon
                icon="ios-checkmark"
                fontSize="60px"
                className="stepIcon"
                color="white"
              />{" "}
            </button>
          </div>
        </div>
        <div className="infoStep ">
          <div className="infoStepHeading">
            <p>
              2{" "}
              <Ionicon
                icon="ios-arrow-round-forward"
                fontSize="30px"
                className="stepIcon"
              />
              &nbsp;Tag your categories
            </p>
          </div>
          <div className="infoStepBody">
            {/* <input type="text" placeholder="" size="20" maxLength="12" className="lefAlign" /> */}
            <ReactTags
              tags={tags}
              handleDelete={this.handleDelete}
              handleAddition={this.handleAddition}
              delimiters={delimiters}
              placeholder="Seperate with comma"
              allowDeleteFromEmptyInput={true}
            />
          </div>
        </div>
        <div className="infoStep ">
          <div className="infoStepHeading">
            <p>
              3{" "}
              <Ionicon
                icon="ios-arrow-round-forward"
                fontSize="30px"
                className="stepIcon"
              />
              &nbsp;Is it a Product or a Service ?
            </p>
          </div>
          <div className="infoStepBody">
            <div className="answerRow">
              <label for="answer_A" className="perfectCenter">
                <span ref="A">A </span>
                <span>PRODUCT </span>
              </label>
              <input
                type="radio"
                value="product"
                id="answer_A"
                name="productORservice"
                onChange={this.handleChange}
              />
            </div>
            <div className="answerRow">
              <label for="answer_B" className="perfectCenter">
                <span ref="B">B </span>
                <span>SERVICE </span>
              </label>
              <input
                type="radio"
                value="service"
                id="answer_B"
                name="productORservice"
                onChange={this.handleChange}
              />
            </div>
            <label />
          </div>
        </div>
        <div className="infoStep ">
          <div className="infoStepHeading">
            <p>
              4{" "}
              <Ionicon
                icon="ios-arrow-round-forward"
                fontSize="30px"
                className="stepIcon"
              />
              &nbsp;Discribe it with one sentence:
            </p>
          </div>
          <div className="infoStepBody">
            <input
              size="30"
              maxLength="30"
              type="text"
              name="discribeQuestion"
              value={this.state.discribeQuestion}
              onChange={this.handleChange}
              className="lefAlign"
            />
          </div>
        </div>
        <div className="infoStep ">
          <div className="infoStepHeading">
            <p>
              5{" "}
              <Ionicon
                icon="ios-arrow-round-forward"
                fontSize="30px"
                className="stepIcon"
              />
              &nbsp;Your target countries
            </p>
          </div>
          <div className="infoStepBody">
            <ReactTags
              tags={targetCountries}
              suggestions={this.state.suggestions}
              handleDelete={this.handleDeleteCountries}
              handleAddition={this.handleAdditionCountries}
              delimiters={delimiters}
              placeholder="Seperate with comma"
              allowDeleteFromEmptyInput={true}
            />
          </div>
        </div>
        <span
          onClick={() => {
            this.props.step("back");
          }}
        >
          {NavigationArrow("prev")}
        </span>
        {this.state.saved && Saved}
      </div>
    );
  };
}
